import React, { Fragment, useEffect, useState } from 'react';
import { connect } from "react-redux";
import Sidebar from './../Sidebar';
import ContactSearch from '../ContactBook/ContactSearch';
import ProductSearch from '../ProductMaster/ProductSearch';
import Swal from "sweetalert2";
import { requestSavePurchase } from "../../Redux/actions";
import { bindActionCreators } from "redux";
import { Modal, ModalBody, ModalHeader, Row } from "reactstrap";

import {
    Box,
    Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Paper
} from '@mui/material';
import { el } from 'date-fns/locale';
import ContactAdd from './../ContactBook/ContactAdd';
import ProductAdd from './../ProductMaster/ProductAdd';
import StoreSearch from '../Store/StoreSearch';
import { parse } from 'date-fns';
import StoreAdd from '../Store/StoreAdd';
import { Navigate } from 'react-router-dom';

const initialTableData = {
    client: '',
    table: '',
    waiter: '',
    items: [],
    discount: 0,
    other: 0,
    paid: 0,
    balance: 0,
    contact: null
};

function PurchaseAdd(props) {
    const [cartData, setCartData] = useState(initialTableData);
    const [selectedTable, setSelectedTable] = useState('');
    const [selectedContact, setSelectedContact] = useState(null);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [products, setProducts] = useState(null);
    // const savedData = selectedContact ? localStorage.getItem(`Purchase_${selectedContact.custId}`) : null;
    // const parsedData = savedData ? JSON.parse(savedData) : null;
    // setProducts(parsedData?.products || []);
    const [userToken, setUserToken] = useState(0);
    const [updated, setUpdated] = useState(false);
    const [contactmodal, setcontactModal] = useState(false);
    const [productmodal, setproductModal] = useState(false);
    const [billdata, setBillData] = useState({
        custId: 0, billNo: "", billDate: null, dueDate: null, person: "", discount: 0, discountpercent: 0, other: 0,
        total: 0, grandTotal: 0, paid: 0, balance: 0
    });

    const [errorBillNo, seterrorBillNo] = useState("");
    const [errorBillDate, seterrorBillDate] = useState(null);

    function validateBillNo() {
        let formIsValid = false;
        console.log(billdata);
        if (!billdata["billNo"]) {
            formIsValid = false;
            seterrorBillNo("*Enter Bill No.");
        } else {
            formIsValid = true;
            seterrorBillNo("");
        }
        return formIsValid;
    }

    function validateBillDate() {
        let formIsValid = false;

        if (!billdata.billDate) {
            formIsValid = false;
            seterrorBillDate("*Enter a Bill date.");
        }
        else {
            formIsValid = true;
            seterrorBillDate("");
        }

        return formIsValid;
    }

    function validateAddForm() {
        let billno = validateBillNo(); let billdate = validateBillDate();
        console.log(billno, billdate);
        let valid = billno && billdate;
        if (!valid) {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Please fill all the required fields correctly.",
            });
        }
        return valid;
    }

    useEffect(() => {
        // localStorage.removeItem(`Purchase_${selectedContact.custId}`);
        if (selectedContact) {
            console.log(selectedContact);
            const savedData = localStorage.getItem(`Purchase_${selectedContact.custId}`);
            const parsedData = savedData ? JSON.parse(savedData) : null;
            setProducts(parsedData?.products || null);
            setCartData(prev => ({
                ...prev,
                items: parsedData?.products || null,
                contact: selectedContact
            }));
            setBillData((adddata) => ({
                ...adddata,
                'custId': selectedContact.custId,
            }))
        }
    }, [selectedContact?.custId]);

    const onchangeadddata = (event) => {
        setBillData((adddata) => ({
            ...adddata,
            [event.target.name]: event.target.value,
        }));
    };

    function deletedata(idToDelete) {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                const tableKey = `Purchase_${selectedContact.custId}`;
                const storedData = JSON.parse(localStorage.getItem(tableKey)) || {};

                // 🛡️ Safe fallback if products don't exist
                const currentProducts = Array.isArray(storedData.products) ? storedData.products : [];

                // 🔍 Remove only the product with the matching id
                const updatedProducts = currentProducts.filter(item => item.id !== idToDelete);
                setProducts(updatedProducts);
                // 🧩 Preserve other table data
                const updatedTableData = {
                    ...storedData,              // Keeps contact, tableNo, etc.
                    products: updatedProducts  // Replaces only the products array
                };

                // 💾 Save back to localStorage
                localStorage.setItem(tableKey, JSON.stringify(updatedTableData));

                // 🔄 Update UI
                // setProductList(updatedProducts);
                setCartData(prev => ({ ...prev, items: updatedProducts }));
            }
        })
    }

    function handleNewClient(e) {
        e.preventDefault();
        contacttoggle();
    }

    const contacttoggle = () => {
        setcontactModal(prev => !prev);
    };

    function handleNewProduct(e) {
        e.preventDefault();
        producttoggle();
    }

    const producttoggle = () => {
        setproductModal(prev => !prev);
    };

    // useEffect(() => {
    //     let data1 = JSON.parse(localStorage.getItem("user"));
    //     if (data1) {
    //         setUserToken(data1.data.userToken);
    //         const savedData = selectedContact ? localStorage.getItem(`Purchase_${selectedContact.custId}`) : null;
    //         const parsedData = savedData ? JSON.parse(savedData) : null;
    //         if (parsedData) {
    //             setProducts(parsedData.products); // Or however you're managing this data
    //             setCartData(prev => ({ ...prev, items: parsedData.products }));
    //         }
    //     }
    // }, [selectedTable]);

    useEffect(() => {
        if (selectedProduct) {
            if (selectedContact === null) {
                Swal.fire({
                    title: 'Error!',
                    text: 'Select Contact first.',
                    icon: 'error'
                });
            } else {
                const current = Array.isArray(products) ? products : [];
                const exists = current.some(p => p.id === selectedProduct.id);
                if (exists) return;

                const newItem = {
                    id: selectedProduct.id,
                    item_name: selectedProduct.description,
                    rate: selectedProduct.rate,
                    qty: 1,
                    discper: 0,
                    disc: 0,
                    taxPer: 0,
                    cgst: 0,
                    sgst: 0,
                    igst: 0,
                    amount: selectedProduct.rate
                };

                const updated = [...current, newItem];

                // 🧩 Save to localStorage
                const dataToSave = {
                    products: updated,
                    contact: selectedContact,
                    billInfo: billdata
                };

                localStorage.setItem(`Purchase_${selectedContact.custId}`, JSON.stringify(dataToSave));

                // 🧠 Update all relevant states
                setProducts(updated);
                setCartData(prev => ({ ...prev, items: updated }));
                setSelectedProduct(null); // use null instead of empty array to avoid logic collisions
            }
        }
    }, [selectedProduct]);

    function saveCartToApi() {
        setUpdated(true);
        let data1 = JSON.parse(localStorage.getItem("user"));
        console.log(validateAddForm());
        if (data1 && validateAddForm() && selectedContact) {
            console.log({
                userToken: data1.data.userToken,
                compToken: localStorage.getItem("companyToken"),
                cartDatas: products,
                billInfo: billdata
            });
            props.requestSavePurchase({
                data: {
                    userToken: data1.data.userToken,
                    compToken: localStorage.getItem("companyToken"),
                    // custId: selectedContact.custId,
                    cartDatas: products,
                    billInfo: billdata
                },
            });
        }
        else {
            Swal.fire({
                title: 'Error',
                text: 'Failed to update cart.',
                icon: 'error'
            });

        }
    }

    useEffect(() => {
        let savePurchaseData = props.data.savePurchaseData;
        if (savePurchaseData !== undefined && updated) {
            if (savePurchaseData?.data?.status === 1) {
                Swal.fire({
                    title: 'Good job!',
                    text: 'Cart saved successfully.',
                    icon: 'success'
                });
                setUpdated(false);
                props.data.savePurchaseData = undefined;
                localStorage.removeItem(`Purchase_${selectedContact.custId}`);
                Navigate('/purchaselist/1/10'); // Redirect to purchase list after saving
            } else {
                Swal.fire({
                    title: 'Error',
                    text: savePurchaseData?.data?.message || 'Failed to update cart.',
                    icon: 'error'
                });
            }
        }
    }, [props.data.savePurchaseData]);

    const handleQtyChange = (id, field, value) => {
        const updatedList = products.map(item => {
            if (item.id !== id) return item;

            const updatedItem = { ...item, [field]: value };

            const discount = updatedItem.discper > 0
                ? (updatedItem.rate * updatedItem.discper) / 100
                : updatedItem.disc ?? 0;

            updatedItem.disc = discount;
            const baseAmount = updatedItem.rate - discount;
            const totalTax = updatedItem.taxPer > 0
                ? (baseAmount * updatedItem.taxPer) / 100
                : (updatedItem.cgst ?? 0) + (updatedItem.sgst ?? 0) + (updatedItem.igst ?? 0);
            updatedItem.cgst = totalTax / 2;
            updatedItem.sgst = totalTax / 2;
            updatedItem.amount = updatedItem.qty * (baseAmount + totalTax);

            return updatedItem;
        });

        setProducts(updatedList);
        updateTables(updatedList); // ✅ pass the updated array
    };

    // const handleQtyChange = (id, newQty, rate, discount, disPer, tax) => {
    //     const updatedProducts = products.map(item => {
    //         if (item.id !== id) return item;
    //         const discount = item.disc;
    //         if (disPer !== item.disper) {
    //             discount = item.discper > 0
    //                 ? (rate * item.discper) / 100
    //                 : item.disc ?? 0;
    //         }

    //         const baseAmount = item.rate - discount;

    //         const totalTax = item.tax > 0
    //             ? (baseAmount * item.tax) / 100
    //             : (item.cgst ?? 0) + (item.sgst ?? 0) + (item.igst ?? 0);

    //         return {
    //             ...item,
    //             qty: newQty,
    //             disc: discount,
    //             amount: newQty * (baseAmount + totalTax)
    //         };
    //     });
    //     console.log(updatedProducts);
    //     updateTables(updatedProducts);
    // };

    function updateTables(updatedProducts) {
        console.log(updatedProducts);
        const updatedTableData = {
            products: updatedProducts,
            contact: selectedContact,
            billInfo: billdata
        };

        // Update state
        setProducts(updatedProducts);
        setCartData(prev => ({ ...prev, items: updatedProducts }));

        // Save to localStorage
        localStorage.setItem(`Purchase_${selectedContact.custId}`, JSON.stringify(updatedTableData));
    }

    const totalAmount = (cartData.items || []).reduce((sum, item) => sum + item.amount, 0);

    // const discountAmount = (totalAmount * billdata.discountpercent) / 100;
    // const grandTotal = totalAmount - (discountAmount || 0) + (billdata.other || 0);
    // const balance = grandTotal - billdata.paid;

    useEffect(() => {
        const discountAmount = (totalAmount * billdata.discountpercent) / 100;
        const grandTotal = totalAmount - discountAmount + parseFloat(billdata.other);
        const balance = grandTotal - parseFloat(billdata.paid);

        setBillData(adddata => ({
            ...adddata,
            total: totalAmount,
            discountAmount: discountAmount,
            balance: balance,
            grandTotal: grandTotal
        }));
    }, [totalAmount, billdata.other, billdata.discountpercent, billdata.paid]);

    return (
        <Fragment>
            <div class="container-scroller">
                {/* <PageHeader name="Jobs" /> */}
                <div class="container-fluid page-body-wrapper">
                    <Sidebar name="Jobs" />
                    <div class="main-panel">
                        <div class="content-wrapper">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="home-tab">
                                        <div class="row flex-grow">
                                            <div class="grid-margin stretch-card">
                                                <div class="card card-rounded">
                                                    <div class="row card-body">
                                                        <div class="col-md-4 card mb-3">
                                                            <div class="card-body">
                                                                <div className="form-group">
                                                                    <ContactSearch onContactSelect={(contact) => {
                                                                        setSelectedContact(contact);
                                                                        setCartData(prev => ({
                                                                            ...prev,
                                                                            contact: contact // 💾 Save into cartData
                                                                        }));
                                                                    }} />
                                                                    <br></br><br></br>
                                                                    {selectedContact !== null ? <div className='row'> <label className="form-label"><b>Name:</b> {selectedContact.name}</label>
                                                                        <label className="form-label"><b>Phone No:</b> {selectedContact.mobile} <b>Email:</b> {selectedContact.email}</label>
                                                                        <div className='row'>{selectedContact.address}</div>
                                                                    </div> : <p>Select Vendor</p>}
                                                                </div>
                                                                <button type='button' className='bg-primary' style={{ width: "20px" }} onClick={(e) => handleNewClient(e)}><i className='fa fa-plus' /></button>
                                                                {contactmodal === true && (
                                                                    <Modal
                                                                        isOpen={contactmodal}
                                                                        toggle={contacttoggle}
                                                                        zIndex='999'
                                                                    >
                                                                        <ModalHeader toggle={contacttoggle}>
                                                                            Contact Details
                                                                        </ModalHeader>
                                                                        <ModalBody>
                                                                            <ContactAdd></ContactAdd>
                                                                        </ModalBody>
                                                                    </Modal>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4 card mb-3">
                                                            <div class="card-body">
                                                                <div className="row">
                                                                    <div className='col-md-6'><input type="text" name='billNo' className="form-control" placeholder="Bill No" value={billdata.billNo} onChange={onchangeadddata} onBlur={validateBillNo}></input>{errorBillNo && <p>{errorBillNo}</p>}</div>
                                                                    <div className='col-md-6'><input type="date" name='billDate' className="form-control" placeholder="Bill Date" value={billdata.billDate} onChange={onchangeadddata} onBlur={validateBillDate}></input>{errorBillDate && <p>{errorBillDate}</p>}</div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className='col-md-6'>Due Date</div>
                                                                    <div className='col-md-6'><input type="date" name='dueDate' className="form-control" placeholder="Due Date" onChange={onchangeadddata}></input></div>
                                                                </div>
                                                                <input type="text" name='person' className="form-control" placeholder="Person" onChange={onchangeadddata}></input>
                                                            </div>
                                                        </div>
                                                        <div class="card mb-3">
                                                            <div class="card-body form-fields">
                                                                <div className='row'>
                                                                    <StoreSearch onStoreelect={(p) => setSelectedProduct(p)}></StoreSearch>
                                                                    <button className='badge badge-opacity-warning' style={{ width: "50px" }} onClick={(e) => handleNewProduct(e)}><i className='fa fa-plus'></i></button>
                                                                    {productmodal === true && (
                                                                        <Modal
                                                                            isOpen={productmodal}
                                                                            toggle={producttoggle}
                                                                            zIndex='999'
                                                                        >
                                                                            <ModalHeader toggle={producttoggle}>
                                                                                Add Product
                                                                            </ModalHeader>
                                                                            <ModalBody>
                                                                                <StoreAdd></StoreAdd>
                                                                            </ModalBody>
                                                                        </Modal>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="card mb-3">
                                                            <div class="row card-body form-fields">
                                                                <Box sx={{ overflowX: 'auto' }}>
                                                                    <TableContainer component={Paper} sx={{ maxHeight: 300 }}>
                                                                        <Table stickyHeader size="small">
                                                                            <TableHead>
                                                                                <TableRow>
                                                                                    <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>#</TableCell>
                                                                                    <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>Item Name</TableCell>
                                                                                    <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>Price</TableCell>
                                                                                    <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>Qty</TableCell>
                                                                                    <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>Disconut %</TableCell>
                                                                                    <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>Disconut</TableCell>
                                                                                    <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>Tax</TableCell>
                                                                                    <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>CGST</TableCell>
                                                                                    <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>SGST</TableCell>
                                                                                    <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>IGST</TableCell>
                                                                                    <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>Amount</TableCell>
                                                                                </TableRow>
                                                                            </TableHead>
                                                                            <TableBody>
                                                                                {Array.isArray(products) ? products.map((item, index) => (
                                                                                    <TableRow
                                                                                        key={index}
                                                                                        hover
                                                                                        sx={{
                                                                                            cursor: 'pointer',
                                                                                            backgroundColor: index % 2 === 0 ? 'white' : '#f5f5f5' // Light gray for odd rows
                                                                                        }}
                                                                                    >
                                                                                        <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>{index + 1}</TableCell>
                                                                                        <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>{item.item_name || '—'}</TableCell>
                                                                                        <TableCell>
                                                                                            <input
                                                                                                type="number"
                                                                                                min="1"
                                                                                                value={item.rate}
                                                                                                onChange={(e) => handleQtyChange(item.id, 'rate', parseFloat(e.target.value))}
                                                                                                style={{ width: '60px', padding: '4px' }}
                                                                                            />
                                                                                        </TableCell>
                                                                                        <TableCell>
                                                                                            <input
                                                                                                type="number"
                                                                                                min="1"
                                                                                                value={item.qty}
                                                                                                onChange={(e) => handleQtyChange(item.id, 'qty', parseFloat(e.target.value))}
                                                                                                style={{ width: '60px', padding: '4px' }}
                                                                                            />
                                                                                        </TableCell>
                                                                                        <TableCell>
                                                                                            <input
                                                                                                type="number"
                                                                                                min="1"
                                                                                                value={item.discper}
                                                                                                onChange={(e) => handleQtyChange(item.id, 'discper', parseFloat(e.target.value))}
                                                                                                style={{ width: '60px', padding: '4px' }}
                                                                                            />
                                                                                        </TableCell>
                                                                                        <TableCell>
                                                                                            <input
                                                                                                type="number"
                                                                                                min="1"
                                                                                                value={item.disc}
                                                                                                onChange={(e) => handleQtyChange(item.id, 'disc', parseFloat(e.target.value))}
                                                                                                style={{ width: '60px', padding: '4px' }}
                                                                                            />
                                                                                        </TableCell>
                                                                                        <TableCell>
                                                                                            <input
                                                                                                type="number"
                                                                                                min="1"
                                                                                                value={item.taxPer}
                                                                                                onChange={(e) => handleQtyChange(item.id, 'taxPer', parseFloat(e.target.value))}
                                                                                                style={{ width: '60px', padding: '4px' }}
                                                                                            />
                                                                                        </TableCell>
                                                                                        <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>{item.cgst}</TableCell>
                                                                                        <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>{item.sgst}</TableCell>
                                                                                        <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>{item.igst}</TableCell>
                                                                                        <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>{item.amount}</TableCell>
                                                                                        <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}><button class="badge badge-opacity-danger" style={{ border: "0px", background: "#fea8a9", marginLeft: "5px", }}
                                                                                            onClick={() => { deletedata(item.id); }}><i class="fa fa-trash"></i></button></TableCell>
                                                                                    </TableRow>
                                                                                )) : ""}
                                                                            </TableBody>
                                                                        </Table>
                                                                    </TableContainer>
                                                                </Box>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <button onClick={() => {
                                if (selectedTable !== '') {
                                    setTables({ ...tables, [selectedTable]: cartData });
                                    alert('Data saved for table: ' + selectedTable);
                                }
                            }}>Save Table Data</button> */}
                            <div
                                style={{
                                    position: 'sticky',
                                    bottom: 0,
                                    width: '100%',
                                    background: '#fff',
                                    boxShadow: '0 -2px 5px rgba(0,0,0,0.1)',
                                    padding: '1rem',
                                    zIndex: 99
                                }}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        flexWrap: 'wrap'
                                    }}
                                >

                                    <strong style={{ fontSize: '1.2rem' }}>Total: ₹{billdata.total}</strong>
                                    <div className='d-flex flex-row justify-content-between'>
                                        <input
                                            name='discountpercent'
                                            type='number'
                                            placeholder='Disc %'
                                            value={billdata.discountpercent}
                                            onChange={onchangeadddata}
                                            className='form-control mx-1 w-60'
                                        />
                                        <input name='discount' type='number' placeholder='Discount' className='form-control mx-1 w-60' disabled value={billdata.discount} />
                                        <input
                                            name='other'
                                            type='number'
                                            placeholder='Other'
                                            value={billdata.other}
                                            onChange={onchangeadddata}
                                            className='form-control mx-1 w-60'
                                        />
                                    </div>
                                    <div className='row'>
                                        <strong style={{ fontSize: '1.2rem' }}>Grand Total: ₹{billdata.grandTotal}</strong>
                                        <div className='d-flex flex-row justify-content-between'>
                                            <input
                                                name='paid'
                                                type='number'
                                                placeholder='Paid'
                                                value={billdata.paid}
                                                onChange={onchangeadddata}
                                                className='form-control mx-1 w-60'
                                            />
                                            <strong className='mx-1 w-60' style={{ fontSize: '1rem' }}> ₹{billdata.balance}</strong>
                                        </div>
                                    </div>
                                    <button
                                        className="btn btn-primary"
                                        onClick={() => { saveCartToApi() }}
                                    >
                                        Save Cart
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

const mapStateToProps = (state) => {
    return { data: state.data };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({ requestSavePurchase }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseAdd);